import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

// Components
import { Navigation } from "./components/Navigation";
import { OrangeDecorations } from "./components/OrangeDecorations";
import { Footer } from "./components/Footer";
import { MobileBottomNav } from "./components/MobileBottomNav";

// Pages
import { HomePage } from "./pages/HomePage";
import { WeddingPage } from "./pages/WeddingPage";
import { AccommodationPage } from "./pages/AccommodationPage";
import { LogisticsPage } from "./pages/LogisticsPage";
import { GalleryPage } from "./pages/GalleryPage";
import { GiftsPage } from "./pages/GiftsPage";
import { RSVPPage } from "./pages/RSVPPage";
import { AdminPage } from "./pages/AdminPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Check if current route is admin
const useIsAdminRoute = () => {
  const { pathname } = useLocation();
  return pathname === '/admin';
};

function AppContent() {
  const isAdmin = useIsAdminRoute();
  
  return (
    <div className="min-h-screen flex flex-col relative">
      {!isAdmin && <OrangeDecorations />}
      {!isAdmin && <Navigation />}
      <main className="flex-1 relative z-10 pb-24 md:pb-0">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mariage" element={<WeddingPage />} />
          <Route path="/hebergement" element={<AccommodationPage />} />
          <Route path="/logistique" element={<LogisticsPage />} />
          <Route path="/galerie" element={<GalleryPage />} />
          <Route path="/cadeaux" element={<GiftsPage />} />
          <Route path="/rsvp" element={<RSVPPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <MobileBottomNav />}
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppContent />
      </BrowserRouter>
      <Toaster 
        position="top-center" 
        richColors 
        toastOptions={{
          style: {
            fontFamily: 'Lato, sans-serif'
          }
        }}
      />
    </div>
  );
}

export default App;
